import { render } from "./BuyInsManager.vue?vue&type=template&id=608763ba&scoped=true"
import script from "./BuyInsManager.vue?vue&type=script&lang=js"
export * from "./BuyInsManager.vue?vue&type=script&lang=js"

import "./BuyInsManager.vue?vue&type=style&index=0&id=608763ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608763ba"]])

export default __exports__